/**
 * Sign-in reconciliation (BR-12): compare the browser decision with the signed-in user's latest
 * server decision and converge both sides on the most recent one. Expired or stale-notice records
 * count as absent on either side (BR-9). Every failure is swallowed silently (BR-13,
 * NFR-OBSERVABILITY-1); the next reconciliation retries.
 */
import { isConsentCurrent, readStoredConsent } from './cookie.js';
import { setAnalyticsConsent } from './store.js';
export async function reconcileServerConsent(deps) {
    const now = deps.now ?? (() => new Date());
    try {
        const fetched = await deps.fetchServerConsent();
        const server = fetched && isConsentCurrent(fetched, now()) ? fetched : null;
        // Read the browser side after the fetch, so a choice made while it was in flight wins.
        const browser = readStoredConsent(now());
        if (!server && !browser)
            return;
        const applyServer = () => {
            if (!server)
                return;
            setAnalyticsConsent(server.analytics, 'sync', { decidedAt: server.decidedAt, upload: false });
        };
        const uploadBrowser = async () => {
            if (!browser)
                return;
            await deps.putServerConsent({
                analytics: browser.analytics,
                noticeVersion: browser.noticeVersion,
                source: 'sync',
                decidedAt: browser.decidedAt,
            });
        };
        if (!browser)
            return applyServer();
        if (!server)
            return await uploadBrowser();
        if (server.analytics === browser.analytics)
            return;
        if (Date.parse(server.decidedAt) > Date.parse(browser.decidedAt))
            return applyServer();
        await uploadBrowser();
    }
    catch {
        // Best-effort (BR-13): consent sync must never block or error the app, and must not log.
    }
}
//# sourceMappingURL=reconcile.js.map